export class Status {
    public static readonly success: string = 'Success';
    public static readonly warning: string = 'Warning';
    public static readonly fail: string = 'Fail';
}

export class MessageQueueItemDirectionType {
    public static readonly In: string = 'In';
    public static readonly Out: string = 'Out';
    public static readonly DeadletterToInbox: string = 'DeadletterToInbox';
}

export class KeyboardCodes {
    public static readonly ENTER: string = 'Enter';
    public static readonly ESCAPE: string = 'Escape';
    public static readonly BACKSPACE: string = 'Backspace';
}

export class GlobalConfig {
    public static readonly Group = 'Global';
    public static readonly SendBookingRemarks: string = 'SendBookingRemarks'
}

export class PrincipalConfig {
    public static readonly FlightsGantGroup: string = 'flightsGantGroup';
    public static readonly ReportGridStateKey: string = 'reportGridState';
    public static readonly ReportFiltersKey: string = 'reportFilters';

    public static readonly RoomsMainGridGroup: string = 'roomsMainGridGroup';
    public static readonly PassengersGridGroup: string = 'passengersGridGroup';
    public static readonly MasterDataAgenciesGridGroup: string = 'masterDataAgenciesGridGroup';
    public static readonly MasterDataTaxGridGroup: string = 'masterDataTaxGridGroup';

    public static readonly MasterDataGroup: string = 'MasterData';
    public static readonly TaxConfigDefaultValue: string = 'XfTaxDefaultValue';

    public static readonly ViewGroup: string = 'view';
    public static readonly DarkMode: string = 'darkMode';
}

export class SignalREvents {
    public static readonly jobStatusChanged: string = 'jobStatusChanged';
    public static readonly jobProgressMaxValueChanged: string = 'jobProgressMaxValueChanged';
    public static readonly jobProgressValueChanged: string = 'jobProgressValueChanged';
    public static readonly sendJobTimeline: string = 'sendJobTimeline';

    public static readonly refreshRoom: string = 'refreshRoom';

    public static readonly flightLocked: string = 'flightLocked';
}

export class ParameterType {
    public static readonly DateTime: string = 'DateTime';
    public static readonly Date: string = 'Date';
    public static readonly Boolean: string = 'Boolean';
    public static readonly MultiLine: string = 'Multiline';
    public static readonly SingleLine: string = 'String';
    public static readonly Integer: string = 'Integer';
    public static readonly Enum: string = 'Enum';
}

export class Airline {
    public static readonly Codes: string[] = ['WK', 'LX']
}